/*! Copyright Notice. Powered by MaxDesign.
  ⚠ FR : CONTENU PROTÉGÉ PAR LES DROITS D'AUTEURS (article L. 111-1 du code de la propriété intellectuelle). Cette ressource ne peut pas être utilisée, diffusée ou exploitée sans l'approbation de ses auteurs. Pour plus d'informations, veuillez contacter admin(at)maxdesign.expert
  ⚠ EN : CONTENT PROTECTED WITH AUTHOR COPYRIGHTS (section L. 111-1 of the intellectual property code). This resource may not be used, distributed or exploited without the approval of its authors. For any information request, please contact admin(at)maxdesign.expert
*/

class Header extends HTMLElement {
  constructor() {
    super();
    this.settings = JSON.parse(this.querySelector(':scope > [type="application/json"]').innerText);
    this.onCloseMenuHandler = this.closeMenu.bind(this);
    this.setVariables();
    this.setEvents();
  }

  setVariables() {
    this.root = document.documentElement;
    this.scrollPos = window.pageYOffset || this.root.scrollTop;
    this.header = this.parentElement;
    this.dom = {
      drawerContainer: this.querySelector('.md-header__container'),
      menuToggler: this.querySelector('.md-header__toggle'),
      menuParent: this.querySelector('.md-header__list--parent'),
      menuParentItems: this.querySelectorAll('.md-header__item--parent > a'),
      menuSwitchers: this.querySelectorAll('[data-level-aim]'),
    };
  }

  setEvents() {
    this.isSticky() && addEventListener('scroll', this.stickyHeader.bind(this));
    this.onResize();
    this.onToggleDrawer();
    this.onSwitchMenu();
  }

  /*************************
    MAIN METHODS
  *************************/

  onResize() {
    window.addEventListener('resize', () => {
      this.resetMenu();
      this.setProperties();
    });
  }

  onToggleDrawer() {
    this.dom.menuToggler.addEventListener('click', () => {
      let isMenuOpen = this.root.hasAttribute('header-open');
      if (isMenuOpen) {
        this.resetMenu();
        this.root.removeEventListener('click', this.onCloseMenuHandler);
      } else {
        this.setProperties();
        this.root.addEventListener('click', this.onCloseMenuHandler);
      }
      this.root.toggleAttribute('header-open');
    });
  }

onSwitchMenu() {
  /* desktop */
  if (!Shopify.designMode) this.addEventListener('mouseleave', this.closeMenu.bind(this));

  // TOP LEVEL: OPEN ON HOVER (DESKTOP)
  for (let item of this.dom.menuParentItems) {

    // when mouse enters a top-level link, open its submenu
    item.addEventListener('mouseenter', e => {
      if (this.isMobile()) return; // desktop only

      this.root.setAttribute('header-open', '');
      this.dom.menuParent.classList.add('md-header__list--open');

      // mark only this item as open
      this.dom.menuParentItems.forEach(li =>
        li.toggleAttribute('data-level-open', li === item)
      );
    });

    // on desktop, allow normal click navigation (no preventDefault)
    item.addEventListener('click', e => {
      if (this.isMobile()) return; // mobile logic handled below

      // OPTIONAL: if you want first click NOT to navigate, uncomment:
      // if (!item.hasAttribute('data-level-open')) {
      //   e.preventDefault();
      // }
    });
  }

  /* mobile */
  for (let switcher of this.dom.menuSwitchers) {
    switcher.addEventListener(
      'click',
      e => {
        if (this.isMobile()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          // switch to active menu
          if (switcher.nodeName == 'BUTTON') {
            this.resetMenu(false, [switcher.closest('li').firstElementChild]);
          } else {
            switcher.setAttribute('data-level-open', '');
            switcher
              .closest('.md-header__nav--content, .md-header__content')
              .scroll(0, 0);
          }
          // translate drawer
          let levelAim = +switcher.dataset.levelAim;
          let translateX =
            levelAim == 3 ? '-200%' : levelAim == 2 ? '-100%' : '0%';
          this.dom.drawerContainer.style.transform = `translateX(${translateX})`;
        }
      },
      true
    );
  }
}


  stickyHeader() {
    let scrolled = window.pageYOffset || this.root.scrollTop;
    let revealHeader = scrolled < this.scrollPos || scrolled < 300;
    // toggle sticky header
    this.header.classList.toggle('header-maxdesign--sticky', revealHeader || this.root.hasAttribute('header-open'));
    // reset scroll pos
    if (scrolled - this.scrollPos > 200 || this.scrollPos > scrolled) this.scrollPos = scrolled;
  }

  /*************************
  HELPER METHODS
	*************************/

  setProperties() {
    this.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    this.style.setProperty('--header-top-position', `${this.header.getBoundingClientRect().top}px`);
  }

  isMobile() {
    return window.matchMedia('(max-width:768px)').matches;
  }

  isSticky() {
    return (this.settings.sticky.mobile && this.isMobile()) || (this.settings.sticky.desktop && !this.isMobile());
  }

  /**
   * close menu on overlay click
   * @param {event} e
   */
  closeMenu(e) {
    if (!e || e.target == e.currentTarget) {
      this.root.removeAttribute('header-open');
      this.resetMenu();
      this.root.removeEventListener('click', this.onCloseMenuHandler);
    }
  }

  /**
   * reset menu state
   * @param {boolean} translate - hide menu drawer
   * @param {Array} levels - levels to reset
   */
  resetMenu(translate = true, levels = this.querySelectorAll('[data-level-open]')) {
    for (let level of levels) level.removeAttribute('data-level-open');
    if (translate) this.dom.drawerContainer.style.transform = 'translateX(0%)';
    this.dom.menuParent.classList.remove('md-header__list--open');
  }
}

customElements.get('header-maxdesign') || customElements.define('header-maxdesign', Header);
